import { WebFileTypeMapping, } from '../types';
import { getFilesFromFileList, handleImagePickerError } from '../utils';
const useDocumentPicker = () => {
    const createInputElement = (options) => {
        const [bodyElem] = document.getElementsByTagName('body');
        const inputElem = document.createElement('input');
        inputElem.setAttribute('type', 'file');
        inputElem.setAttribute('multiple', options.allowMultiple ? 'true' : 'false');
        inputElem.setAttribute('accept', WebFileTypeMapping[options.allowedTypes]);
        inputElem.setAttribute('hidden', 'true');
        inputElem.style.visibility = 'hidden';
        bodyElem.appendChild(inputElem);
        return inputElem;
    };
    const triggerFilePicker = (inputElem) => {
        return new Promise((resolve, reject) => {
            inputElem.addEventListener('cancel', () => {
                const error = new Error('Document Picker closed');
                error.name = 'DOCUMENT_PICKER_CANCELLED';
                reject(error);
            });
            inputElem.addEventListener('change', () => {
                if ((inputElem.files?.length ?? 0) >= 1) {
                    resolve(inputElem.files);
                }
                else {
                    const error = new Error('No file selected');
                    error.name = 'DOCUMENT_PICKER_NO_FILE_SELECTED';
                    reject(error);
                }
            });
            inputElem.click();
        });
    };
    return {
        async pick(options) {
            const inputElem = createInputElement(options);
            try {
                const response = await triggerFilePicker(inputElem);
                return getFilesFromFileList(response);
            }
            catch (error) {
                if (![
                    'DOCUMENT_PICKER_CANCELLED',
                    'DOCUMENT_PICKER_NO_FILE_SELECTED',
                ].includes(error.name)) {
                    handleImagePickerError(error);
                }
            }
            finally {
                inputElem.remove();
            }
            return null;
        },
    };
};
export default useDocumentPicker;
